/* ============================================================
   assets/tds-theme.js
   Núcleo JS del tema — The Decant Society
   ============================================================ */

(function () {
  'use strict';

  window.TDS = window.TDS || {};

  TDS.debounce = function (fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () { fn.apply(context, args); }, wait);
    };
  };

  TDS.cart = {
    get: function () {
      return fetch('/cart.js').then(function (res) { return res.json(); });
    },
    add: function (formData) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      }).then(function (res) {
        if (!res.ok) { throw new Error('No se pudo agregar el producto al carrito'); }
        return res.json();
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    initProgressiveTabs();
  });

  /**
   * Mejora progresiva: convierte cualquier grupo [data-tds-tabs]
   * (acordeón semántico con <details>) en tabs horizontales en
   * desktop, sin duplicar contenido en el DOM. Centralizado aquí
   * porque el mismo comportamiento lo usan Producto y cualquier
   * sección futura que necesite tabs (ver snippets/breadcrumbs.liquid
   * para el patrón equivalente de markup compartido).
   */
  function initProgressiveTabs() {
    var groups = document.querySelectorAll('[data-tds-tabs]');
    if (!groups.length) return;

    var DESKTOP_QUERY = window.matchMedia('(min-width: 1024px)');

    groups.forEach(function (group) {
      var panels = group.querySelectorAll('[data-tds-tab-panel]');
      if (!panels.length) return;

      function enhance() {
        group.setAttribute('data-tds-enhanced', 'true');

        // Construir la lista de títulos de tabs una sola vez
        if (!group.querySelector('.tds-tabs__list')) {
          var list = document.createElement('div');
          list.className = 'tds-tabs__list';
          panels.forEach(function (panel) {
            var title = panel.querySelector('[data-tds-tab-title]');
            if (title) list.appendChild(title.cloneNode(true));
          });
          group.insertBefore(list, group.firstChild);

          list.querySelectorAll('[data-tds-tab-title]').forEach(function (titleClone, index) {
            titleClone.addEventListener('click', function () {
              activatePanel(index);
            });
          });
        }

        activatePanel(0);
      }

      function activatePanel(activeIndex) {
        panels.forEach(function (panel, index) {
          panel.classList.toggle('is-active-tab', index === activeIndex);
          panel.open = true; // mantiene accesible el contenido para lectores de pantalla
        });
      }

      function revert() {
        group.removeAttribute('data-tds-enhanced');
        var list = group.querySelector('.tds-tabs__list');
        if (list) list.remove();
        panels.forEach(function (panel, index) {
          panel.classList.remove('is-active-tab');
          panel.open = index === 0;
        });
      }

      function sync() {
        if (DESKTOP_QUERY.matches) { enhance(); } else { revert(); }
      }

      sync();
      DESKTOP_QUERY.addEventListener('change', sync);
    });
  }
})();
